import { API_BASE_URL, performTokenRefresh } from "@repo/api";
import type { HostConfig } from "./hostConfig";

export interface UniversalOnboardingHostConfig extends HostConfig {}

const isDev = import.meta.env.DEV;

export function getUniversalOnboardingHostConfig(
  onNavigate?: (path: string) => void,
): UniversalOnboardingHostConfig {
  const apiBaseUrl = isDev
    ? `${window.location.origin}/api-proxy`
    : (import.meta.env.VITE_API_BASE_URL as string) || window.location.origin;

  return {
    basename: "/integrations/universalOnboarding",
    apiBaseUrl,
    onUnauthorized: () => performTokenRefresh(API_BASE_URL),
    onNavigate,
  };
}
